import { render } from "./CompleteCourse.vue?vue&type=template&id=45eab707"
import script from "./CompleteCourse.vue?vue&type=script&lang=js"
export * from "./CompleteCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__